import { Spinner, useToast } from '@chakra-ui/react';
import { InputTextMask, InputTextMaskProps } from 'components/Atomos/Form/Elements/InputTextMask';
import { Location } from 'models/location.model';
import { useState } from 'react';
import { FieldValues } from 'react-hook-form';
import masks from 'utils/masks/masks';

type CepFieldProps<T extends FieldValues> = Omit<InputTextMaskProps<T>, "mask"> & {
    onCepInformationReceive?: (location: Location) => void;
};

const CepField = <T extends FieldValues>({
    onCepInformationReceive,
    ...rest
}: CepFieldProps<T>) => {
    const [loading, setLoading] = useState(false);
    const toast = useToast();
    return (
        <InputTextMask
            {...rest}
            rightIcon={loading ? <Spinner /> : undefined}
            mask={masks.ZIP_CODE}
        />
    )
}

export default CepField